/**
 * 関係性型定義
 * NPCの他NPCに対する関係性を表現
 */

export interface Relationship {
  targetId: string;              // 相手のNPC ID
  affection: number;             // 好感度（-100 ~ 100）
  interactionCount: number;      // 交流回数
  lastInteractionDay: number;    // 最終交流日
  relationType: RelationType;    // 関係タイプ
}

/**
 * 関係タイプ
 */
export type RelationType =
  | 'stranger'      // 他人（0-20）
  | 'acquaintance'  // 知人（20-40）
  | 'friend'        // 友人（40-60）
  | 'close_friend'  // 親友（60-80）
  | 'partner'       // パートナー（80-100）
  | 'rival';        // ライバル（負の好感度）

/**
 * 好感度から関係タイプを判定
 */
export function determineRelationType(affection: number): RelationType {
  if (affection < 0) return 'rival';
  if (affection < 20) return 'stranger';
  if (affection < 40) return 'acquaintance';
  if (affection < 60) return 'friend';
  if (affection < 80) return 'close_friend';
  return 'partner';
}

/**
 * 関係性を新規作成
 */
export function createRelationship(targetId: string, day: number): Relationship {
  return {
    targetId,
    affection: 0,
    interactionCount: 0,
    lastInteractionDay: day,
    relationType: 'stranger',
  };
}

/**
 * 関係タイプの日本語名
 */
export function getRelationTypeName(type: RelationType): string {
  const names: Record<RelationType, string> = {
    stranger: '他人',
    acquaintance: '知人',
    friend: '友人',
    close_friend: '親友',
    partner: 'パートナー',
    rival: 'ライバル',
  };
  return names[type];
}
